import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import { setNavigationState } from 'app/core/store/actions/ui.actions';
import { Clinic } from 'app/shared/clinics/models/clinic.model';
import { LayoutSize } from 'app/shared/layout/models/layout-size.enum';
import { NavigationItem, newNavigationItem } from 'app/shared/layout/models/navigation-item.model';
import { SideBarStateEnum } from 'app/shared/layout/models/side-bar-state.enum';
import { WindowSizeModel } from 'app/shared/layout/services/window-size.model';
import { Identifier, LocalStorageService } from 'app/shared/storage/services/local-storage.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'core-lay-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationItemComponent implements OnInit, OnDestroy {
  @Input() navBarState?: SideBarStateEnum;
  @Input() item: NavigationItem = newNavigationItem();
  sideBarStateEnum = SideBarStateEnum;
  isActive?: boolean;
  currentClinic?: Clinic;
  windowSize?: WindowSizeModel;
  private subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private localStorageService: LocalStorageService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscribeToNavigationStart();
    this.subscribeToClinicLocalStorage();
    this.subscribeToWindowSizeChange();
  }

  onNavItemClick(url: string): void {
    if (url) {
      this.router.navigate([url]).then();
      if (this.windowSize && this.windowSize.width <= LayoutSize.lg) {
        this.store.dispatch(setNavigationState({ navState: SideBarStateEnum.Close }));
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToWindowSizeChange(): void {
    this.subscription.add(
      this.store.pipe(select(fromRoot.getWindowSizeChanged)).subscribe(windowSizeChanged => {
        this.windowSize = windowSizeChanged;
      })
    );
  }

  private subscribeToClinicLocalStorage(): void {
    this.subscription.add(
      this.localStorageService.getStorageItem(Identifier.TYPE_CLINIC).subscribe(clinic => {
        if (clinic) {
          this.currentClinic = JSON.parse(clinic);
        }
        this.ref.markForCheck();
      })
    );
  }

  private subscribeToNavigationStart(): void {
    this.subscription.add(
      this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(nav => {
        let urlSegment = '';
        const urlArray = this.item.url?.split('/') || [];
        urlArray.forEach(function iterate(item, index, array) {
          if ((index !== array.length - 1 || array.length === 1) && index <= 1) {
            urlSegment += `/${item}`;
          }
        });
        this.isActive =
          this.item.url && nav instanceof NavigationStart ? nav.url?.includes(urlSegment) : false;
        this.ref.markForCheck();
      })
    );
  }
}
